module.exports = __webpack_public_path__ + "img/complispace-logo.89bdc9c0.svg";